import { AppHeader, UserMenu } from "@tfg/ui"

import { SupplierAppLanguageMenu } from "~/components/layout/SupplierAppLanguageMenu"
import { useSupplierUserMenuItems } from "~/components/layout/use-supplier-user-menu-items"
import { useAuth } from "~/store/auth-context"

export const SupplierOnboardingHeader = () => {
  const { user } = useAuth()
  const menuItems = useSupplierUserMenuItems()

  if (!user) return null

  return (
    <AppHeader theme="supplier" h="var(--mantine-supplier-header-height)">
      <SupplierAppLanguageMenu />
      <UserMenu user={user} menuItems={menuItems} withAvatar={false} />
    </AppHeader>
  )
}
